module.exports = __webpack_public_path__ + "media/images/email/ic_outlook-8764783b6c71a9f440c97d982831437c.svg";